<template lang='pug'>
    #purchase-tax-document-pending
        r-table(
            no-data-text='Sin documentos por pagar.'
            no-remove
            v-bind='tableProps'
            @detail='submitDetail'
        )
        r-dialog(
            no-confirm
            v-bind='dialogProps'
            v-model='dialog'
        )
            template( v-if='isCreditNote' )
                r-form(
                    v-bind='creditProps'
                    v-model='selected'
                    ref="invoiceDetail"
                )
            template( v-else-if='isDebitNote' )
                r-form(
                    v-bind='debitProps'
                    v-model='selected'
                )
            template( v-else-if='isInvoice' )
                r-form(
                    v-bind='invoiceProps'
                    v-model='selected'
                )
</template>

<script>
    //
    import { mapActions } from 'vuex'
    import { RDialog, RForm, RTable } from '@/components/reusable_components/next'
    import PurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'
    import PurchaseDebitNoteModel from '@/models/Purchase/PchPurchaseDebitNote'
    import PurchaseCreditNoteModel from '@/models/Purchase/PchPurchaseCreditNote'
    import TaxDocumentModel from '@/models/Purchase/PchTaxDocument'
    //
    import PurchaseInvoiceFields from '@/views/Purchase/PchPurchaseInvoice/PchPurchaseInvoiceFields'
    import PurchaseDebitNoteFields from '@/views/Purchase/PchPurchaseDebitNote/PchPurchaseDebitNoteFields'
    import PurchaseCreditNoteFields from '@/views/Purchase/PchPurchaseCreditNote/PchPurchaseCreditNoteFields'
    import TaxDocumentPendingFilters from '@/views/Purchase/PchTaxDocument/PchTaxDocumentFilters'
    import TaxDocumentPendingHeaders from '@/views/Purchase/PchTaxDocument/PchTaxDocumentHeaders'
    import moment from 'moment'
    import ProviderBranchOfficeModel from '@/models/Purchase/PchProviderBranchOffices'
    //
    export default {
        name: 'purchase-tax-document-pending',
        components: {
            RDialog,
            RForm,
            RTable,
        },
        computed: {
            creditParams() {
                return {
                    document_type_title: this.selected.document_type ? 'Documento: Nota de debito' : 'Documento: Factura de compra',
                    pch_provider_branch_offices: this.selected.pch_provider_branch_offices,
                    pch_provider_trigger: this.triggerProvider,
                }
            },
            /**
             *
             */
            creditProps () {
                return {
                    editable: false,
                    fields: PurchaseCreditNoteFields(this.creditParams).variant(this.selected.document_type),
                    //loading: this.busy,
                }
            },

            /**
             *
             */
            debitProps () {
                return {
                    editable: false,
                    fields: PurchaseDebitNoteFields(this.debitParams).variant(this.selected.document_type),
                }
            },

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            dialogProps() {
                return {
                    title: this.dialogTitle,
                }
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            dialogTitle() {
                return `${this.isInvoice ? 'Factura de compra' : this.isCreditNote ? 'Nota de credito' : this.isDebitNote ? 'Nota de debito' : 'Documento de compra' } #${this.selected.id}`
            },

            /**
             *
             */
            formProps() {
                return {
                    fields: [],
                }
            },

            /**
             *
             */
            invoiceProps () {
                return {
                    editable: false,
                    fields: PurchaseInvoiceFields(this.arrProviderBranch),
                }
                
            },

            /**
             * Determines if credit note.
             */
            isCreditNote() {
                return this.document_type_number === 61
            },

            /**
             * Determines if debit note.
             */
            isDebitNote() {
                return this.document_type_number === 56
            },

            /**
             * Determines if invoice.
             */
            isInvoice() {
                return this.document_type_number === 33
            },

            /**
             *
             */
            tableProps() {
                return {
                    filters: TaxDocumentPendingFilters,
                    headers: TaxDocumentPendingHeaders,
                    service: TaxDocumentModel,
                    paramsFilter:{
                        pending_debts_to_pay: true,
                    },
                    initialFilterValues: {
                        payment_date: moment().format('YYYY-MM-DD'),
                    },
                    
                }
            },
            /*
             */
            debitParams() {
                return {
                    document_type_title: this.selected.document_type ? 'Documento: Nota de debito' : 'Documento: Factura de compra',
                    pch_provider_branch_offices: this.arrProviderBranch,
                    pch_provider_trigger: this.triggerProvider,
                }
            },
        },
        data() {
            return {
                dialog: false,
                document_type_number: 33,
                selected: {},
                arrProviderBranch:[],
            }
        },
        methods: {

            //
            ...mapActions('MenuesModule', ['setTitleTopBar']),

            /**
             * Fetches a purchase invoice.
             *
             * @param      {<type>}  id      The identifier
             * @return     {<type>}  The purchase invoice.
             */
            fetchPurchaseInvoice(id) {
                return PurchaseInvoiceModel
                    .modeler()
                    .find(id)
                    .then(this.setPurchase)
            },
            /*
             */
            fetchPurchaseDebitNote(id) {
                return PurchaseDebitNoteModel
                    .modeler()
                    .find(id)
                    .then(this.setPurchase)
            },
            /*
             */
            fetchPurchaseCreditNote(id) {
                return PurchaseCreditNoteModel
                    .modeler()
                    .find(id)
                    .then(this.setPurchase)
            },

            /**
             * Sets the purchase .
             *
             * @param      {<type>}  model   The model
             */
            setPurchase(model) {
                this.selected = model.reset()
                //this.$refs.invoiceDetail.value.pch_provider_branch_offices_id=1
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  item    The item
             */
            submitCreditNoteDetail(item) {
                this.fetchPurchaseCreditNote(item.id)
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  item    The item
             */
            submitDebitNoteDetail(item) {
                this.fetchPurchaseDebitNote(item.id)
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  item    The item
             */
            submitInvoiceDetail(item) {
                this.fetchPurchaseInvoice(item.id)
            },

            /**
             *
             */
            submitDetail(event) {

                //
                console.log({ event })
                this.arrProviderBranch = [event.item.pch_provider_branch_offices]
                //
                switch (event.item.document_type_number) {
                    case 33: this.submitInvoiceDetail(event.item); break;
                    case 61: this.submitCreditNoteDetail(event.item); break;
                    case 56: this.submitDebitNoteDetail(event.item); break;
                }

                //
                this.dialog = true
                this.document_type_number = event.item.document_type_number
            },
            /*
             */
            triggerProvider(ctx) {
                this.selected.pch_provider_branch_offices = this.arrProviderBranch   
            }
        },
        beforeMount() {
            this.setTitleTopBar('Documentos pendientes')
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can('VIEW_ALL_PCH_PURCHASE_INVOICE_PAID'))
                    ctx.$router.push('/')
            })
        },
    }
</script>